/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Owner = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getOwner: function(id, callback) {
		var url = "owner/" + id;
		var data = this.server.getData(url,null,true);
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
			console.log(e);
		});
	},
	updateUserAccount: function(ownerData, callback) {
		modal.showDangerModalWithOK("Are you sure?","You are about to update this owner account.","Yes, Update");
		jQuery(".move-on").on('click',function() {
			var url = "owner/" + ownerData.owner_id;
			var params = ownerData;
			var data = server.getData(url, params, true, "PUT");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1) {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2)) {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                }
                if(callback) {
                    callback(response);
                }
			})
			.fail(function(e){
                modal.resetBackDrop();
				modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
			});
		});
    },
	deleteOwnerAccount: function(ownerId, callback) {
		modal.showDangerModalWithOK("Are you sure?","You are about to remove this owner.","Yes, Delete");
		jQuery(".move-on").on('click',function() {
			var url = "owner/" + ownerId;
			var params = null;
			var data = server.getData(url,params,false, "DELETE");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1) {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2)) {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                }
                if(callback) {
                    callback(response);
                }
			})
			.fail(function(e){
                modal.resetBackDrop();
				modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
			});
		});
    },
	saveOwnerAccount: function(ownerData, callback) {
		modal.showDangerModalWithOK("Are you sure?","You are about to add this owner account.","Yes, Add");
		jQuery(".move-on").on('click',function() {
			var url = "owner/new";
			var params = ownerData;
			var data = server.getData(url,params, true, "POST");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1) {
                }
                else if(response.data.error || (response.status == 1 || response.status == 2)) {
                    modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
                }
                if(callback) {
                    callback(response);
                }
			})
			.fail(function(e){
                modal.resetBackDrop();
				modal.showInfo(e.responseText, "danger", "top", "center");
			});
		});
    },
	sendActivation: function(id, callback) {
		var self = this;
		var url = "owner/invite/" + id;
		var data = self.server.getData(url, null, true, "POST");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo(e.responseText, "danger", "top", "center");
		});
	},
	getOwnerExpectedIncome: function(callback) {
		var url = "owner/income";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo(e.responseText, "danger", "top", "center");
		});
	},
	getOwnerPMFeeCharges: function(callback) {
		var url = "owner/fees";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if(callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo(e.responseText, "danger", "top", "center");
		});
	},
});

export let owner = new Owner();


// WEBPACK FOOTER //
// app/core/controllers/Owner.js